import React from "react";
import { motion } from "framer-motion";

const GRADIENTS = [
  "from-rose-500 to-red-700",
  "from-amber-500 to-orange-600",
  "from-emerald-500 to-teal-700",
  "from-fuchsia-500 to-purple-700",
  "from-yellow-500 to-amber-700",
  "from-pink-500 to-rose-600",
];

export const EventsShowcase = ({ categories, counts, onPick }) => {
  return (
    <section className="relative bg-[#120E0C] py-16 sm:py-20 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, #f59e0b 0, transparent 40%), radial-gradient(circle at 80% 60%, #f43f5e 0, transparent 40%)" }} />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs tracking-widest uppercase font-semibold text-amber-400">Occasions for every celebration</span>
          <h2 className="mt-2 font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-50">
            Events We <span className="festive-text">Craft</span>
          </h2>
          <p className="mt-3 text-stone-300/80">Tap an occasion to explore its invites instantly.</p>
        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-3 sm:gap-4">
          {categories.map((cat, i) => (
            <motion.button
              key={cat}
              data-testid={`event-showcase-${cat}`}
              onClick={() => onPick(cat)}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 8) * 0.05 }}
              whileHover={{ y: -4 }}
              className={`group relative px-5 sm:px-7 py-3 sm:py-4 rounded-2xl bg-gradient-to-br ${GRADIENTS[i % GRADIENTS.length]} shadow-lg text-white overflow-hidden`}
            >
              <span className="relative z-10 font-serif text-lg sm:text-2xl font-semibold tracking-tight">
                {cat}
              </span>
              {counts[cat] ? (
                <span className="relative z-10 ml-2 inline-flex items-center justify-center text-[11px] font-semibold bg-white/25 rounded-full px-2 py-0.5 align-middle">
                  {counts[cat]}
                </span>
              ) : null}
              <span className="absolute inset-0 bg-white/0 group-hover:bg-white/15 transition-colors duration-300" />
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
